export default "__VITE_ASSET__CbPB36Q8__"